(function($, undefined) {
	
	'use strict';
	var searchInput;
	var searchCtn;
	var resultsCtn;
	var clonesCtn;
	var artistsCtn;
	var agenciesCtn;
	var demosCtn;
	var blogsCtn;
	var infosJson;
	var noResultsText;
	
	var searchRequest;
	var searchTimeout;
	var searchDelay = 500;

	var ajaxSearch = function(e) {
		var $inp = $(e.target);
		var val = $inp.val().trim();
		
		if (searchRequest) searchRequest.abort();
		if (searchTimeout) clearTimeout(searchTimeout);
		
		if (val !== $inp.attr('data-mem')) {
			if (val.length > 1) {
				searchTimeout = setTimeout(function() {
					$inp.attr('data-mem', val);
					searchRequest = $.ajax({
						url: '/action/vcSiteSearch',
						cache: false,
						method: 'POST',
						data: { q: val, ajax: true },
						success: displaySearchResults
					});
				}, searchDelay);
			} else if (val.length === 1) {
				$inp.attr('data-mem', val);
				displaySearchResults('');
			} else {
				$inp.attr('data-mem', val);
				resetSearch(true);
			}
		}
	};

	var displaySearchResults = function(response) {
		cleanSearchCtn(artistsCtn);
		cleanSearchCtn(agenciesCtn);
		cleanSearchCtn(demosCtn);
		cleanSearchCtn(blogsCtn);

		if (response.length) {
			response.forEach(function(category) {
				generateAndAppendItems(category);
			});
		}

		toggleSearchCtn(artistsCtn);
		toggleSearchCtn(agenciesCtn);
		toggleSearchCtn(demosCtn);
		toggleSearchCtn(blogsCtn);

		!response || response.length === 0 ? noResultsText.slideDown(200) : noResultsText.slideUp(200);
		searchCtn.slideDown(200);

		// !response || response.length === 0 ? searchCtn.slideUp(100) : searchCtn.slideDown(200);
	};

	var generateAndAppendItems = function(category) {
		var ctn;
		var itemsArray;
		var type = Object.getOwnPropertyNames(category)[0];

		if (type === 'artists') {
			ctn = artistsCtn;
			itemsArray = category.artists;
		} else if (type === 'agencies') {
			ctn = agenciesCtn;
			itemsArray = category.agencies;
		} else if (type === 'demos') {
			ctn = demosCtn;
			itemsArray = category.demos;
		} else if (type === 'blogs') {
			ctn = blogsCtn;
			itemsArray = category.blogs;
		}

		var readMore = ctn.closest('.search-results-section').find('.search-section-read-more');

		itemsArray.forEach(function(item, index) {
			readMore.attr('href', readMore.attr('data-prefix') + searchInput.val() + readMore.attr('data-suffix'));
			itemsArray.length > 3 ? readMore.slideDown() : readMore.slideUp();
			
			if (index < 3) {
				var clone,
					urlId,
					img,
					title,
					text;

				if (type === 'artists') { 
					clone = clonesCtn.find('.search-result.artist').clone();
					urlId  = item.id;
					title = item.firstName + ' ' + item.lastName;
					text = '';

					if (item.addInfo13 !== undefined && item.addInfo13 !== '') {
						var ids = item.addInfo13.split(',');
						ids.forEach(function(item, index) {
							if (index !== 0) {
								text += '/ ';
							}
							text += infosJson[item];
						});
					}
				} else if (type === 'agencies') {
					clone = clonesCtn.find('.search-result.agency').clone();
					urlId  = item.id;
					title = item.addInfo3 !== undefined && item.addInfo3.length ? name = item.addInfo3 : item.firstName + ' ' + item.lastName;
					text = '';

					if (item.addInfo12 !== undefined && item.addInfo12 !== '') {
						var ids = item.addInfo12.split(',');
						ids.forEach(function(item, index) {
							if (index !== 0) {
								text += '/ ';
							}
							text += infosJson[item];
						});
					}
				} else if (type === 'demos') {
					clone = clonesCtn.find('.search-result.demo').clone();
					urlId  = item.friendlyUrl;
					title = item.field2;
					text = item.firstName + ' ' + item.lastName;
				} else if (type === 'blogs') {
					clone = clonesCtn.find('.search-result.blog').clone();
					urlId  = item.friendlyUrl;
					title = item.title;
					text = item.intro.length < 200? item.intro : item.intro.substring(0, 200) + '...';
				}

				clone.attr('href', clone.attr('data-url') + urlId);
				img = clone.find('.search-result-img');
				img.attr('style', img.attr('data-prefix') + item.mediaId + img.attr('data-suffix'));
				clone.find('.search-result-title').html(encodeText(title));
				clone.find('.search-result-text').html(encodeText(text));

				ctn.append(clone);
			}
		});
	};

	var cleanSearchCtn = function(ctn) {
		ctn.children().remove();
	};

	var toggleSearchCtn = function(ctn) {
		ctn.children().length === 0 ? ctn.closest('.search-results-section').slideUp() : ctn.closest('.search-results-section').slideDown();
	};

	var encodeText = function(str) {
		if (str !== undefined) {
			str = str.replace(/\\xE0/g, '\xE0');
			str = str.replace(/\\xE2/g, '\xE2');
			str = str.replace(/\\xE3/g, '\xE3');
			str = str.replace(/\\xE4/g, '\xE4');
			str = str.replace(/\\xE5/g, '\xE5');
			str = str.replace(/\\xE7/g, '\xE7');
			str = str.replace(/\\xE9/g, '\xE9');
			str = str.replace(/\\xE8/g, '\xE8');
			str = str.replace(/\\xEA/g, '\xEA');
			str = str.replace(/\\xEB/g, '\xEB');
			str = str.replace(/\\xEE/g, '\xEE');
			str = str.replace(/\\xEF/g, '\xEF');
			str = str.replace(/\\xF1/g, '\xF1');
			str = str.replace(/\\xF2/g, '\xF2');
			str = str.replace(/\\xF3/g, '\xF3');
			str = str.replace(/\\xF4/g, '\xF4');
			str = str.replace(/\\xF6/g, '\xF6');
			str = str.replace(/\\xF9/g, '\xF9');
			str = str.replace(/\\xFB/g, '\xFB');
			str = str.replace(/\\xC0/g, '\xC0');
			str = str.replace(/\\xC2/g, '\xC2');
			str = str.replace(/\\xC7/g, '\xC7');
			str = str.replace(/\\xC8/g, '\xC8');
			str = str.replace(/\\xC9/g, '\xC9');
			str = str.replace(/\\xCA/g, '\xCA');
			str = str.replace(/\\xCB/g, '\xCB');
			str = str.replace(/\\xCE/g, '\xCE');
			str = str.replace(/\\xCF/g, '\xCF');
			str = str.replace(/\\xD1/g, '\xD1');
			str = str.replace(/\\xD4/g, '\xD4');
			str = str.replace(/\\xD9/g, '\xD9');
			str = str.replace(/\\xDB/g, '\xDB');
			return str;
		}
	};

	var resetSearch = function(keepValue) {
		searchCtn.slideUp(200);
		noResultsText.slideDown();
		cleanSearchCtn(artistsCtn);
		cleanSearchCtn(agenciesCtn);
		cleanSearchCtn(demosCtn);
		cleanSearchCtn(blogsCtn);
		toggleSearchCtn(artistsCtn);
		toggleSearchCtn(agenciesCtn);
		toggleSearchCtn(demosCtn);
		toggleSearchCtn(blogsCtn);
		if (!keepValue) {
			searchInput.val('');
			searchInput.attr('data-mem', '');
		}
	};

	var closeSearch = function() {
		resetSearch();
	};
	
	var init = function () {
		searchInput = $('.header-search-input');
		searchCtn = $('.site-ajax-search-ctn');
		resultsCtn = $('.site-ajax-results-ctn');
		clonesCtn = $('.site-ajax-clones-ctn');
		artistsCtn = resultsCtn.find('.search-results-section.artists .search-results-inner');
		agenciesCtn = resultsCtn.find('.search-results-section.agencies .search-results-inner');
		demosCtn = resultsCtn.find('.search-results-section.demos .search-results-inner');
		blogsCtn = resultsCtn.find('.search-results-section.blogs .search-results-inner');
		noResultsText = $('.site-ajax-search-no-results-found');
		$('.close-ajax-site-search-btn').click(closeSearch);
		
		if (searchCtn.length) {
			infosJson = JSON.parse(searchCtn.attr('data-json'));
		}

		searchInput.on("input", ajaxSearch);

		if (searchCtn.length || resultsCtn.length) {
			$(window).resize(function() {
				resetSearch();
			});
		}
	};
	
	$(init);
	
})(jQuery);